import Script from "next/script"
import React from "react"

const GTM_OCTOPUS_URL = "https://load.tag.octopusenergy.fr"

type GoogleTagManagerProps = {
    gtmId: string
}

export function CustomGoogleTagManager({ gtmId }: GoogleTagManagerProps) {
    return (
        <>
            <Script
                id="_next-gtm-init"
                dangerouslySetInnerHTML={{
                    __html: `
                    (function(w,d,s,i){
                        w.dataLayer=w.dataLayer||[];
                        w.dataLayer.push({'gtm.start':new Date().getTime(),event:'gtm.js'});
                        var f=d.getElementsByTagName(s)[0],j=d.createElement(s);
                        j.async=true;
                        j.src="${GTM_OCTOPUS_URL}/bzvivufdfjx.js?"+i;
                        f.parentNode.insertBefore(j,f);
                    })(window,document,'script','22y=EQ5bIzI4WydAWSw2JThQH0VYSFVAERhUFwkSCxYABQwWDxQDH1sQGw%3D%3D');`,
                }}
            />
            <noscript>
                <iframe
                    src={`${GTM_OCTOPUS_URL}/ns.html?id=${gtmId}`}
                    height="0"
                    width="0"
                    style={{ display: "none", visibility: "hidden" }}
                />
            </noscript>
        </>
    )
}

export const sendGTMEvent = (data: object) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
}
